import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/esni/')({
  component: () => <Navigate to="/esni/media" />,
});
